import { post } from './http';

export const add = async ({ articleNumber, quantity = 1 }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    const response = await post('/api/cart/add', {
        articleNumber,
        quantity: parseFloat(quantity),
    });
    return response.json();
};

export const monitor = async ({ articleNumber }) => {

    await post('/api/cart/addarticletomonitor', {
        articleNumber,
    });

    return true;
};

export const monitorRemove = async ({ articleNumber }) => {
    await post('/api/cart/removearticle', {
        articleNumber,
    });

    return true;
};

export const wistlistUpdate = async ({ articleNumber }) => {
    const response = await post('/api/cart/addremovearticletoTowishlist', {
        articleNumber,
    });

    return response.json();
};

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};
